import { lazy } from 'react';
import { type RouteObject, Navigate } from 'react-router-dom';

import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/minimal-layout';

const Page404 = Loadable(lazy(() => import('../views/page404')));

const page404Routes: RouteObject[] = [
  {
    path: '/',
    element: <MinimalLayout />,
    children: [
      {
        path: '404',
        element: <Page404 />
      },
      {
        path: '*',
        element: <Navigate to="/404" replace />
      }
    ]
  }
];

export default page404Routes;
